'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { getComputerModeMenuDisplayName } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/chunkAnchor.js';
import { ComputerModeMenuItems as ComputerModeMenuItemsComponent } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/ComputerModeMenuItems.js';
import { useComputerMenuPrefetch } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/useComputerMenuPrefetch.js';
import React from 'react';
export const ComputerMenuPrefetch = function ComputerMenuPrefetch({ collectionUuid, sideChatAvailable = false }) {
    useComputerMenuPrefetch({ collectionUuid, sideChatAvailable });
    return null;
};
export const ComputerModeMenuItems = React.memo(function ComputerModeMenuItemsWrapper(props) {
    return _jsx(ComputerModeMenuItemsComponent, { ...props });
});
ComputerModeMenuItems.displayName = getComputerModeMenuDisplayName();
//# sourceMappingURL=index.js.map